import React from "react";
import { Link } from "../components/L";
import { ArrowRight, Clock, BookOpen } from "lucide-react";
import Seo from "../components/Seo";
import CTABand from "../components/CTABand";
import { articles } from "../blog";
import { useLang } from "../context/LanguageContext";

const Blog = () => {
  const { lang, t } = useLang();
  const b = t.blog;
  const seo = lang === "de"
    ? { title: "Putzfrau-Ratgeber: Tipps, Kosten & Vermittlung | MyCleaner.ch", description: "Der grosse Putzfrau-Ratgeber: 20 Artikel zu Putzfrau finden, Putzfrau Vermittlung Schweiz, Kosten, Recht und Reinigungstipps für Ihren Privathaushalt.", keywords: "Putzfrau Ratgeber, Putzfrau Vermittlung Schweiz, Putzfrau gesucht, Haushaltshilfe Tipps, Putzfrau Kosten" }
    : { title: "Cleaner guide: tips, costs & placement | MyCleaner.ch", description: "The big cleaner guide: 20 articles on finding a cleaner, cleaner placement Switzerland, costs, law and cleaning tips for your home.", keywords: "cleaner guide, cleaner placement Switzerland, home help tips, cleaner costs" };

  return (
    <div>
      <Seo pageKey="blog" title={seo.title} description={seo.description} keywords={seo.keywords} />

      <section className="pt-[116px] pb-16 bg-gradient-to-b from-[#faf6ee] to-white">
        <div className="max-w-[820px] mx-auto px-5 md:px-6 text-center">
          <p className="text-[#b8893f] font-semibold text-sm tracking-[0.18em] uppercase mb-3">{b.eyebrow}</p>
          <h1 className="font-head font-semibold text-4xl md:text-5xl leading-tight text-[#12211b] mb-5">{b.title}</h1>
          <p className="text-lg text-slate-600">{b.subtitle}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1200px] mx-auto px-5 md:px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((a) => (
              <Link key={a.slug} to={`/ratgeber/${a.slug}`} className="group bg-white rounded-2xl border border-[#ece4d3] overflow-hidden hover:shadow-xl hover:border-[#d9b45a]/60 transition-all duration-300 flex flex-col">
                <div className="h-2 bg-teal-700" />
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3 text-xs">
                    <span className="bg-teal-50 text-teal-700 font-semibold px-2.5 py-1 rounded-full">{a.cat}</span>
                    <span className="flex items-center gap-1 text-slate-400"><Clock className="w-3.5 h-3.5" /> {a.min} {b.minRead}</span>
                  </div>
                  <h2 className="font-head font-semibold text-[#12211b] text-xl leading-snug mb-3 group-hover:text-teal-700 transition-colors">{((t._pages || {})[`article:${a.slug}`] || {}).title || a.title}</h2>
                  <p className="text-slate-600 text-[15px] leading-relaxed mb-5 flex-1">{((t._pages || {})[`article:${a.slug}`] || {}).excerpt || a.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-teal-700 font-semibold text-sm group-hover:gap-2.5 transition-all">{b.readMore} <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default Blog;
